import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ExpressCreditCard: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--express-credit-card')}
    viewBox="0 0 120 75.4"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g>
      <path d="M6.4 0h107.2c3.5 0 6.4 2.9 6.4 6.4V69c0 3.5-2.9 6.4-6.4 6.4H6.4C2.9 75.4 0 72.5 0 69V6.4C0 2.9 2.9 0 6.4 0z" />
      <path
        d="M106.8 35.9l-1.5-.2c-1.5-.2-2.2-.7-2.2-1.5 0-1 1.3-1.6 2.3-1.6 1.7 0 3.2.7 4.3 2l3-2.2c-1.8-2-4.4-3.1-7-3.1-3.4 0-6.5 1.6-6.5 5.4 0 2.3 1.6 3.9 4.6 4.4l3.3.5c1.2.2 1.8.6 1.8 1.4 0 1.4-1.9 1.8-3 1.8-1.9 0-3.2-.7-4.6-2l-3 2c2.2 2.4 4.5 3.2 7.2 3.2 3 0 7.3-.9 7.3-5.7-.2-2.9-2.8-3.9-6-4.4M90 32.5c1.7 0 3.2.7 4.3 2l3-2.2c-1.8-2-4.4-3.1-7-3.1-3.4 0-6.5 1.6-6.5 5.4 0 2.3 1.6 3.9 4.6 4.4l3.3.5c1.2.2 1.8.6 1.8 1.4 0 1.4-1.9 1.8-3 1.8-1.9 0-3.2-.7-4.6-2l-3 2c2.2 2.4 4.5 3.2 7.2 3.2 3 0 7.3-.9 7.3-5.7 0-3-2.6-4-5.8-4.5l-1.6-.1c-1.5-.2-2.2-.7-2.2-1.5 0-1 1.3-1.6 2.2-1.6m-16.2 6.3H81v-3.1h-7.2v-2.9h7.7v-3.1H69.8v15.9h12.4v-3.1h-8.4v-3.7zM61.7 37h-3.6v-4.3h3.6c1.3 0 2.1.7 2.1 2.1.1 1.5-.8 2.1-2.1 2.2m6.2-2.1c0-3.6-2.2-5.2-5.8-5.2h-8v15.9h4v-5.7h2.5l3.1 5.7h4.5l-3.7-6.4c2.1-.5 3.4-2.2 3.4-4.3m-21.3 2.6h-3.4v-4.9h3.2c1.8 0 2.6.9 2.6 2.5.1 1.3-.6 2.4-2.4 2.4m.6-7.8h-7.9v15.9h4v-5.2h3.1c5.5 0 6.6-3.3 6.6-5.4 0-3.1-1.5-5.3-5.8-5.3m-10 0h-4.8l-2.9 4.9-2.9-4.9h-4.8l5.3 7.4-6.1 8.6h4.8l3.8-6 3.7 6H38l-6.1-8.6 5.3-7.4zm-25.9 9.1h7.2v-3.1h-7.2v-2.9H19v-3.1H7.3v15.9h12.4v-3.1h-8.4v-3.7z"
        fill="#FFFFFF"
      />
    </g>
  </svg>
);

export default ExpressCreditCard;
